import React, { memo } from 'react'
import { TableCell, TableHead, TableRow } from 'transfix-ui'

const MatchingShipmentsTableHeader = memo(() => (
  <TableHead>
    <TableRow>
      <TableCell>Shipment ID</TableCell>
      <TableCell>Equipment</TableCell>
      <TableCell>Pickup Date</TableCell>
      <TableCell>Pickup City</TableCell>
      <TableCell>Delivery Date</TableCell>
      <TableCell>Delivery City</TableCell>
      <TableCell>List Rate</TableCell>
      <TableCell>Shipper</TableCell>
    </TableRow>
  </TableHead>
))

export default MatchingShipmentsTableHeader
